import React, { PropsWithChildren } from 'react';
import Card from '../card/card-wrapper';
import { PureErrorBoundary } from '../';

interface Props {
	title?: string | JSX.Element;
	body?: string | JSX.Element;
}

function ErrorBoundaryComponent({ title, body, children }: PropsWithChildren<Props>) {
	return (
		<PureErrorBoundary
			fallback={() => (
				<div className="error-component">
					<Card
						className="error-card"
						children={
							<>
								<h1 className="title">{title || 'No Data'}</h1>
								<h2>{body || 'could not load component'}</h2>
							</>
						}
					/>
				</div>
			)}
		>
			{children}
		</PureErrorBoundary>
	);
}

export default ErrorBoundaryComponent;
